

export default function Footer() {

    return (
        <footer>Powered by RestoNXT</footer>
    )
}